import { Checkbox } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
import { LOAN_STATUS_OPTIONS } from '@modules/investor/config/loanStatus';
const InvestmentStatus = ({ value, onChange }) => {
    const { t } = useTranslation();
    const handleCheckboxChange = (status, checked) => {
        if (checked) {
            onChange([...value, status]);
            return;
        }
        const next = value.filter((item) => item !== status);
        onChange(next.length === 0 ? [...LOAN_STATUS_OPTIONS] : next);
    };
    const handleSelectAll = () => {
        onChange([...LOAN_STATUS_OPTIONS]);
    };
    const isAllChecked = LOAN_STATUS_OPTIONS.every((option) => value.includes(option));
    return (<div className="flex flex-col gap-2">
            <Checkbox id="investment-status-all" checked={isAllChecked} onChange={handleSelectAll} label={t('financing.investing_page_table.all')}/>
            {LOAN_STATUS_OPTIONS.map((option) => (<Checkbox key={option} id={`investment-status-${option}`} checked={value.includes(option)} onChange={({ target }) => handleCheckboxChange(option, target.checked)} label={t(`financing.loan_status.${option.toLowerCase()}`)}/>))}
        </div>);
};
export default InvestmentStatus;
